import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DeleteIcon from '@material-ui/icons/Delete';
import FolderIcon from '@material-ui/icons/Folder';
import React, { useState } from 'react';
import { globalStyles } from '../style/GlobalStyles';
import { ElabDto } from '../dto/Dtos';
import { CustomDialog } from '../dialog/CustomDialog';

export type ElaborazioneProps = {
    key: any,
    item: ElabDto,
    onCarica: any,
    onCancella: any,
    searchString?: string,
}

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         inline: {
//             textAlign: "center"
//         },
//     })
// );

export function Elaborazione(props: ElaborazioneProps) {
    const gClasses = globalStyles();
    const [dialogOpened, openDialog] = useState<boolean>(false);
    const [dialogCancellaOpened, openCancellaDialog] = useState<boolean>(false);

    function handleClickCarica() {
        openDialog(true);
    }

    function handleClickCancella() {
        openCancellaDialog(true);
    }

    function handleClose() {
        openDialog(false);
    }

    function handleCancellaClose() {
        openCancellaDialog(false);
    }

    function handleOk() {
        props.onCarica(props.item.ID);
    }

    function handleOkCancella() {
        props.onCancella(props.item.ID);
    }

    let show = (
        (
            props.searchString && props.searchString!.length > 0
            &&
            (
                props.item.NomeSimulazione.toUpperCase().includes(props.searchString!.toUpperCase())
                || props.item.Identificativo.toUpperCase().includes(props.searchString!.toUpperCase())
            )
        )
        || props.searchString === undefined || props.searchString!.length === 0);
    return (
        show === false ? <p></p> :
            <Grid item xs={12}>
                <div>
                    <CustomDialog handleClose={handleClose} handleOk={handleOk} open={dialogOpened} title="Conferma caricamento" message="Sei sicuro di procedere con il caricamento? Eventuali modifiche non salvate verrano perse."></CustomDialog>
                    <CustomDialog handleClose={handleCancellaClose} handleOk={handleOkCancella} open={dialogCancellaOpened} title="Conferma cancellazione" message="Vuoi davvero cancellare la simulazione? L'operazione non è reversibile."></CustomDialog>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <DeleteIcon color="error" onClick={handleClickCancella} style={{ cursor: "hand" }} />
                            </ListItemIcon>
                            <ListItemIcon>
                                <FolderIcon color="secondary" onClick={handleClickCarica} style={{ cursor: "hand" }} />
                            </ListItemIcon>
                            <ListItemText
                                onClick={handleClickCarica} style={{ cursor: "hand" }}
                                primary={props.item.NomeSimulazione}
                                secondary={
                                    <React.Fragment>
                                        <Typography
                                            component="span"
                                            variant="body2"
                                            className={gClasses.inline}
                                            color="primary"
                                        >
                                            {props.item.Identificativo}
                                        </Typography>
                                        <br></br>
                                        {props.item.TStamp}
                                    </React.Fragment>
                                }

                            />
                        </ListItem>
                    </List>
                </div>
            </Grid>
    )
}